import { defaultMockedResponse } from "./defaultMockedResponse";
import { clearSessionState } from "./session-state";
import type { DecodedSignedRequest } from "./types";

let mockedResponse: DecodedSignedRequest | undefined;
let mockedStatus = 200;
let fakesEnabled = false;

export function usingFakes(): boolean {
  return fakesEnabled;
}

export function enableFakes(): void {
  fakesEnabled = true;
}

export function disableFakes(): void {
  fakesEnabled = false;
}

export function setMockSignedRequestResponse(mock: DecodedSignedRequest) {
  clearSessionState();
  mockedResponse = mock;
}

export function setSignedRequestResponseStatus(status: number) {
  mockedStatus = status;
}

export function getDefaultMockSignedRequestResponse(): DecodedSignedRequest {
  return fastClone(defaultMockedResponse);
}

export function getMockedStatus() {
  return mockedStatus;
}

export function getMockedResult() {
  return mockedResponse ? fastClone(mockedResponse) : fastClone(defaultMockedResponse);
}

export function clearMocks() {
  mockedResponse = undefined;
  clearSessionState();
  mockedStatus = 200;
}

function fastClone(obj: unknown) {
  return JSON.parse(JSON.stringify(obj));
}
